import {
  LOCAL_SQLITE_PERSIST_FAILURE_EVENT,
  type LocalSqlitePersistFailureDetail,
} from '@core/domain/localSqlitePersistEvents.ts';
import type { NotificationPort } from '@src/modules/shared/notifications/domain/ports/NotificationPort.ts';

const MIN_INTERVAL_MS = 30_000;

/** User-facing toast when IndexedDB export fails (quota, private mode, I/O). */
export function installLocalSqlitePersistFailureListener(notifications: NotificationPort): () => void {
  let lastAt = 0;

  const handler = (ev: Event): void => {
    const detail = (ev as CustomEvent<LocalSqlitePersistFailureDetail>).detail;
    const now = Date.now();
    if (now - lastAt < MIN_INTERVAL_MS) return;
    lastAt = now;
    const msg =
      detail?.message?.trim() ||
      'No se pudo guardar una copia local de la base de datos. Libere espacio en Almacenamiento o sincronice pronto.';
    notifications.warning(msg);
  };

  globalThis.addEventListener(LOCAL_SQLITE_PERSIST_FAILURE_EVENT, handler);
  return () => globalThis.removeEventListener(LOCAL_SQLITE_PERSIST_FAILURE_EVENT, handler);
}
